export const infoList = [
  {
    subtitle: "IMPORTANTE",
    title: "¿POR QUÉ ES IMPORTANTE MEDIR LOS NIVELES DE CO2?",
    image: "https://i.ibb.co/1MdjRcT/adox-ac.png",
    cName: "post",
    texts: [
      {
        text: "El control sobre la concentración de CO2 tiene dos beneficios.",
      },
      {
        text: "El primero es la reducción de la incidencia en la tasa de contagio aéreo de enfermedades como gripe, sarampión, tuberculosis y ahora COVID-19. Cada vez que exhalamos CO2 al ambiente también lo hacemos con los virus que se quedan en el ambiente como el humo. Menos CO2 en ambiente equivale a menos concentración vírica en ambiente.",
      },
      {
        text: "Habitualmente se habla de valores de renovación de aire que aseguren que estamos por debajo de 500 ppm sobre exterior. Esto equivale a unas 900 ppm de umbral máximo. En ambientes sin ventilación los valores suelen estar entre 1500 ppm y 3000 ppm según ratio y tiempo.",
      },
      {
        text: "En pandemia según investigadores de la OMS se habla de umbrales de 700 ppm. Estos valores son indicadores de muy baja concentración de virus o dosis no infectivas en el ambiente.",
      },
      { text: "La ventilación reduce contagios, CO2 dice si está bien." },
      {
        text: "El segundo beneficio es la reducción de la somnolencia/aletargamiento por exposición a valores por encima de 1000 ppm. Si mantenemos un orden cercano a 700 ppm tendremos también el beneficio positivo que da tener un ambiente saludable y activo.",
      },
    ],
  },
  {
    subtitle: "RECOMENDACIONES PARA VENTILACIÓN",
    title: "¿CÓMO VENTILAR APROPIADAMENTE?",
    image:
      "https://i.ibb.co/qRw5yj2/White-classroom-in-education-university-with-blue-chairs.jpg",
    cName: "post",
    texts: [
      {
        text: "1) La ventilación cruzada (dos aperturas opuestas evitando zonas con aire estancado) como la de mayor eficacia con mucha diferencia sobre las de sólo ventanas o sólo puertas. Esta ventilación debe ser continua.",
      },
      {
        text: "2) El reparto de la apertura entre todas las ventanas del ambiente consigue una mejor ventilación. Es más eficaz abrir de forma moderada varias ventanas, que abrir al máximo una sola ventana, aunque la superficie abierta total sea la misma.",
      },
      {
        text: "3) La configuración de la apertura de puertas y ventanas que proporciona una ventilación suficiente puede ser diferente. Se pueden testar diferentes configuraciones y observar cómo varían las concentraciones de CO2.",
      },
      {
        text: "4) Apertura de puertas y ventanas de zonas comunes (pasillos y hall) al exterior como aliviaderos de CO2 de los ambientes y reducción de la contaminación cruzada.",
      },
      {
        text: "5) Las aperturas deben realizarse en el momento en que llegan las personas al ambiente. Hasta ese momento se puede aprovechar para calentarlo. Un ambiente vacío y bien ventilado tras su última ocupación tiene el aire libre de virus y concentraciones de CO2 cercanas a la concentración de fondo. La velocidad de renovación de CO2 es mucho mayor que la velocidad de pérdida de carga térmica en el ambiente.",
      },
      {
        text: "6) Recuperación del ambiente. Es recomendable realizar ventilaciones totales de entre 15-20 min durante períodos del día. Esto consigue renovar bien el aire y mejorar los niveles de CO2.",
      },
      {
        text: "7) Es recomendable conversar en niveles bajos de voz e intentar no desplazarse por diferentes zonas.",
      },
      {
        text: "8) Relación Volumen/Ratio. Entre 15 y 20 personas en ambientes de 75-90 m2 llegan con facilidad a valores bajos de CO2 con ligera apertura de ventanas. Para un mismo número de personas, en aulas más grandes las concentraciones de CO2 son inferiores. Por tanto relaciones volumen/ratio (V/R) más altas son más favorables.",
      },
      {
        text: "9) En comedores ventilación cruzada con aperturas más agresivas o totales ya que las personas no tienen la mascarilla puesta.",
      },
      {
        text: "10) Días ventosos o con altas diferencias de temperatura entre exterior e interior facilitan la ventilación y permiten aperturas menores.",
      },
    ],
  },
  {
    subtitle: "BIBLIOGRAFIA RECOMENDADA",
    title: "¿QUERÉS CONOCER MÁS SOBRE ESTO?",
    image: "",
    cName: "post",
    texts: [
      {
        text: "1) Jorge Aliaga, físico, investigador y principal divulgador científico en la materia.",
        url: "http://www.jorgealiaga.com.ar/",
      },
      {
        text: "2) Normativa: ASTM D6245 − 18 Standard Guide for Using Indoor Carbon Dioxid Concentrations to Evaluate Indoor Air Quality and Ventilation.",
        url: "",
      },
      {
        text: "3) Normativa: ANSI/ASHRAE Addendum d to ANSI/ASHRAE Standard 62.1-2016 Ventilation for Acceptable Indoor Air Quality: ",
        url: "https://www.ashrae.org/File%20Library/Technical%20Resources/Standards%20and%20Guidelines/Standards%20Addenda/62.1-2016/62_1_2016_d_20180302.pdf",
      },
      {
        text: "4) Medición de la concentración de CO2 como indicador de una ventilación adecuada de edificios y locales. COVID19 por Departamento de Salud Ambiental Subdirección General de Salud Pública de Madrid: ",
        url: "https://madridsalud.es/wp-content/uploads/2020/11/InfSAM33-2020Ventilacion_interio_como_medida_preventivaCOVID19.pdf",
      },
      {
        text: "5) Recomendaciones de harvard: ",
        url: "https://bit.ly/3oxuwSB",
      },
      {
        text: "6) Documento adjunto: Guía para ventilación en aulas Instituto de Diagnóstico Ambiental y Estudios del Agua, IDAEA-CSIC. Referenciados en este link con documentación respaldatoria del ministerio de ciencia e innovación de España: ",
        url: "https://www.csic.es/es/actualidad-del-csic/una-guia-del-csic-muestra-como-se-deben-ventilar-las-aulas-para-reducir-el",
      },
      {
        text: "7) Preprint paper: Exhaled CO2 as COVID-19 infection risk proxy for different indoor environments and activities: ",
        url: "https://www.medrxiv.org/content/10.1101/2020.09.09.20191676v2",
      },
      { text: "8) Iniciativa: ", url: "https://www.aireamos.org/" },
    ],
  },
  {
    subtitle: "ADOX - DESARROLLANDO INNOVACIÓN",
    title:
      "Simulador de riesgo de contagio por aerosoles en ambientes cerrados",
    cName: "post",
    texts: [
      {
        text: "El veneno está en la dosis. Bajo tiempo de exposición a concentraciones bajas de CO2 exhalado son el marco de un AMBIENTE SALUDABLE.",
      },
    ],
  },
  {
    subtitle: "PROBABILIDAD DE INFECCIÓN",
    title: "¿QUÉ VALOR DE RIESGO DE INFECCIÓN ES ACEPTABLE?",
    image:
      "https://i.ibb.co/Stc3zGw/Doctor-with-antiseptic-Coronavirus-theme.jpg",
    cName: "post",
    texts: [
      {
        text: "Primero, tenga en cuenta que las incertidumbres son altas, dado que tenemos información limitada sobre las emisiones de cuantas en particular, y no debe sobreinterpretar los resultados. Si obtiene 1% para un caso, en realidad puede ser 0.3% o 4%, pero no será 0.001% o 100%.",
      },
      {
        text: "En segundo lugar, qué riesgo de infección es tolerable es una cuestión para las personas involucradas. Es decir, todos hacemos actividades que implican algún riesgo y lo toleramos porque el riesgo es lo suficientemente bajo en comparación con el beneficio. Por ejemplo, vamos a lugares en automóviles y aviones, aunque hay una pequeña posibilidad de muerte o lesiones al hacer esas cosas, porque valoramos más el viaje. Por ejemplo, dadas las probabilidades de morir en un viaje en automóvil o avión, estamos aceptando un riesgo de 0.00006% y 0.00001% cada vez que viajamos, respectivamente (estimado a partir de las probabilidades de muerte de https://www.nsc.org/work-safety/tools-resources/injury-facts/chart, suponiendo viajar en automóvil la mitad de los días, en avión 8 veces al año, durante una vida útil de 75 años).",
      },
      {
        text: "Para aspectos como el riesgo de cáncer, la EPA de EE.UU. utiliza una probabilidad de 1 en un millón (0,0001%) como límite. Algunos investigadores han sugerido que las personas pueden estar dispuestas a tolerar una probabilidad de 1 en 1000 (0,1%) de infección por COVID-19 en todas sus actividades (no solo en una actividad que puede simular con el estimador, como ir a clase). Pero debe ser usted quien determine esto por sí mismo y por su situación.",
      },
    ],
  },
];
